var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9693 4.01679C13.6725 0.712353 8.32745 0.712353 5.0307 4.01679C3.86182 5.18839 3.10836 6.61601 2.76815 8.11892C2.67437 8.53323 2.26326 8.79288 1.84992 8.69888C1.43658 8.60488 1.17753 8.19281 1.27131 7.77851C1.67371 6.00085 2.56579 4.31174 3.94538 2.92893C7.84154 -0.976311 14.1585 -0.976311 18.0546 2.92893C19.1292 4.00604 19.9047 4.84922 20.4651 5.50622V1.79487C20.4651 1.37004 20.8087 1.02564 21.2326 1.02564C21.6564 1.02564 22 1.37004 22 1.79487V7.94872C22 8.37355 21.6564 8.71795 21.2326 8.71795H15.093C14.6692 8.71795 14.3256 8.37355 14.3256 7.94872C14.3256 7.52388 14.6692 7.17949 15.093 7.17949H19.849C19.3429 6.52717 18.4688 5.51979 16.9693 4.01679ZM20.1501 11.3011C20.5634 11.3951 20.8225 11.8072 20.7287 12.2215C20.3263 13.9992 19.4342 15.6883 18.0546 17.0711C14.1585 20.9763 7.84154 20.9763 3.94538 17.0711C2.87077 15.994 2.09532 15.1508 1.53488 14.4938V18.2051C1.53488 18.63 1.19129 18.9744 0.767442 18.9744C0.343595 18.9744 0 18.63 0 18.2051V12.0513C0 11.6264 0.343595 11.2821 0.767442 11.2821H6.90698C7.33082 11.2821 7.67442 11.6264 7.67442 12.0513C7.67442 12.4761 7.33082 12.8205 6.90698 12.8205H2.151C2.65709 13.4728 3.5312 14.4802 5.0307 15.9832C8.32745 19.2876 13.6725 19.2876 16.9693 15.9832C18.1382 14.8116 18.8916 13.384 19.2319 11.8811C19.3256 11.4668 19.7367 11.2071 20.1501 11.3011Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.a4ab39313e2bf4e080ad6e0fbab160a3.svg";
export { ForwardRef as ReactComponent };